import React from "react";

//Import Image
import lightLogo from "../../assets/images/logo-light.png";
import darkLogo from "../../assets/images/logo-dark.png";

import resetPasswordImage from "../../assets/images/auth/reset-password.png";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";

const ResetPassword = () => {
  document.title =
    "Reset Password | JobSpace - Job Listing Template | Themesdesign";
  return (
    <React.Fragment>
    <div>
      <div className="main-content">
        <div className="page-content">
          <section className="bg-auth">
            <Container>
              <Row className="justify-content-center">
              <div className="p-5 text-white" style={{backgroundColor:"#088B1E", width : "400px"}}>
                            <div className="text-center mb-4">
                              <h5>Reset Password</h5>
                              <p >
                                Reset your password with JobSpace.
                              </p>
                            </div>
                            <Form className="auth-form text-white">
                              <div
                                className="alert alert-warning text-center mb-4"
                                role="alert"
                              >
                                {" "}
                                Enter your Email and instructions will be sent
                                to you!{" "}
                              </div>
                              <div className="mb-4">
                                <label className="form-label" htmlFor="email">
                                  Username/Email
                                </label>
                                <Input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  placeholder="Enter username or email"
                                />
                              </div>
                              <div className="mt-3">
                                <button
                                  type="submit"
                                  className="btn btn-success w-100"
                                >
                                  Send Request
                                </button>
                              </div>
                            </Form>
                            <div className="mt-5 text-center">
                              <p>
                                Remembered It ?{" "}
                                <Link
                                  to="/"
                                  className="fw-medium text-white text-decoration-underline"
                                >
                                  {" "}
                                  Go to Login{" "}
                                </Link>
                              </p>
                            </div>
              </div>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

export default ResetPassword;
